import React, { Component } from 'react';

import Header from '../../../Containers/Header/Header';
import Footer from '../../../Containers/Footer/index';
import MainTopMenu from '../../../Containers/MainTopMenu';
import CategoryIn from '../../../Buttons/CategoryIn';
import PopupAlert from '../../../Containers/PopupAlert';
import * as HomeworkService from '../../../../services/Student/HomeworkService';
import * as Utils from '../../../Utils';
import Loading from "../../../Containers/Loading";

class Main extends Component {
    state = {
        categoryList: [
            // 가데이터 주석처리
            // {id: 0, state:"off", name:"vocabulary", color:"yellow", btnName:"숙제하기", link:"/app/vocabulary", section:"Life", isDone:false},
            // {id: 1, state:"off", name:"listening", color:"orange", btnName:"숙제하기", link:"/app/listening", section:"Life", isDone:false},
            // {id: 2, state:"off", name:"reading", color:"deepPink", btnName:"복습하기", link:"/app/reading", section:"Life", isDone:false},
            // {id: 3, state:"off", name:"speaking", color:"blue", btnName:"숙제하기", link:"/app/speaking", section:"Life", isDone:false},
            // {id: 4, state:"off", name:"writing", color:"pink", btnName:"숙제하기", link:"/app/writing", section:"Life", isDone:false}
        ],
        isDoneAllHomework: true,

        // loading
        isLoadingHide: false
    }

    componentDidMount = () => {
        if (Utils.isConnectedLocalServer()) {
            this.setState({
                categoryList: [
                    {id: 0, state:"off", name:"vocabulary", color:"yellow", btnName:"숙제하기", link:"/app/vocabulary", section:"Life", title:"sample", isDone:false},
                    {id: 1, state:"off", name:"listening", color:"orange", btnName:"숙제하기", link:"/app/listening", section:"Life", title:"sample", isDone:false},
                    {id: 2, state:"off", name:"reading", color:"deepPink", btnName:"복습하기", link:"/app/reading", section:"Life", title:"sample", isDone:false},
                    {id: 3, state:"off", name:"speaking", color:"blue", btnName:"숙제하기", link:"/app/speaking", section:"Life", title:"sample", isDone:false},
                    {id: 4, state:"off", name:"writing", color:"pink", btnName:"숙제하기", link:"/app/writing", section:"Life", title:"sample", isDone:false}
                ]
            });
        } else {
            this.getHomework(Utils.getDate());
        }
        this.state.isLoadingHide = true;
    }

    setCategory = () => {
        const { categoryList } = this.state;
        const list = categoryList.map(
            ({ id, state, name, color, btnName, link, section, title }) => (
                <CategoryIn categoryState={state} categoryName={name} color={color} btnName={btnName} link={link} section={section} title={title} key={id}/>
            )
        );
        return list;
    }

    getHomework = (date) => {
        HomeworkService.getHomework(date).then( (response) => {
            if( response.status === 200 ) {
                let responseData = response.data;
                if( responseData.code === '0000' ) {
                    // console.log(responseData);
                    const categoryList = Utils.setTodayHomework(responseData.data);
                    const donelist = categoryList.filter((x) => x.isDone);
                    this.setState({
                    	categoryList: categoryList,
            	    	isDoneAllHomework: (categoryList.length == 0 || donelist.length == categoryList.length)
                    })

                } else {
                    alert(responseData.data);
                }
            } else {
                alert('GET HOMEWORK ERROR');
            }
        }).catch( response => {
            alert("SERVER ERROR");
        });
    }

    onDateChange = (date) => {
        Utils.setDate(date);
        this.getHomework(date);
    }

    render() {
    	if( !this.state.isLoadingHide ) {
    	    return(<Loading/>);
        }
    	const {categoryList} = this.state;
    	// console.log(categoryList.length === 0);
        return (
            <div className="beaconWrapper">
                <Header selectedIndex={0} />
                <div className="allconWrapper">
                  <div className="contentsWrapper">
                      <h2 className="screenOut">오늘의 숙제</h2>
                      <MainTopMenu isDoneAllHomework={this.state.isDoneAllHomework} onDateChange={this.onDateChange}/>
                      <div className="pageContents">
                          {this.setCategory()}
                      </div>
                  </div>
                </div>
              <Footer />
                <PopupAlert active={(categoryList.length === 0)} message="오늘의 숙제가 없어요!" link="/app/calendar" confirmName="숙제 미리하기" />
            </div>
        );
    }
}
export default Main;



// WEBPACK FOOTER //
// ./src/components/Pages/Student/Main/index.js